import ActionTypes from './ActionTypes';
import { unwrapResult } from '@reduxjs/toolkit';

/* This logic will eventually be removed & the logic contained in GetShiftLogsAction()
   will be moved into the shiftLogSlice after Report.js has been refactored */
// TODO: update this
import store from '../src/store';
import { shiftLogActions } from '../src/store';
import { DdLogs } from '../src/logging/datadog';

export function GetShiftLogsActionAsync(payload) {
  return (dispatch) => {
    let { siteCode, assetName } = payload;
    return store
      .dispatch(
        shiftLogActions.getShiftLogs({
          siteCode: siteCode,
          assetName: assetName,
        }),
      )
      .then((response) => {
        if (response?.meta?.condition) return;
        // Guard against condition-skipped thunks (payload is undefined when deduplicated).
        const data = unwrapResult(response);
        if (Array.isArray(data)) dispatch(GetShiftLogsAction(data));
      });
  };
}

export function AddShiftLogsActionAsync(payload) {
  return (dispatch) => {
    return new Promise(function (resolve, reject) {
      DdLogs.info('goto resolve...');
      resolve(
        dispatch({
          type: ActionTypes.ADD_TEAMSHIFTLOG,
          payload,
          isLoading: false,
        }),
      );
    });
  };
}
export function GetShiftLogsAction(payload) {
  return {
    type: ActionTypes.GET_SHIFTLOGS,
    payload,
  };
}
export function UpdateShiftLogActionAsync(payload) {
  return (dispatch) => {
    let { siteCode, shiftSummaryID } = payload;
    return store
      .dispatch(
        shiftLogActions.downloadFileContent({
          siteCode: siteCode,
          shiftSummaryID: shiftSummaryID,
        }),
      )
      .then((response) => {
        const data = unwrapResult(response);
        if (data) {
          dispatch({
            type: ActionTypes.UPDATE_SHIFTLOG,
            payload: data,
          });
        }
        return data;
      })
      .catch((err) => {
        DdLogs.error('get single shift log err222...', err);
      });
  };
}
export function UpdateTeamShiftLogActionAsync(payload) {
  return (dispatch) => {
    let { siteCode, shiftSummaryID } = payload;

    return store
      .dispatch(
        shiftLogActions.downloadFileContent({
          siteCode: siteCode,
          shiftSummaryID: shiftSummaryID,
        }),
      )
      .then((response) => {
        DdLogs.info('get team shitlog is done......');
        const data = unwrapResult(response);
        if (data) {
          dispatch({
            type: ActionTypes.UPDATE_TEAM_SHIFTLOG,
            payload: data,
          });
        }
        return data;
      })
      .catch((err) => {
        DdLogs.error('get team shift log err...', err);
      });
  };
}

export function GetTeamShiftLogsActionAsync(payload) {
  return (dispatch) => {
    let { siteCode, assetName } = payload;
    return store
      .dispatch(
        shiftLogActions.getTeamShiftLogs({
          siteCode: siteCode,
          assetName: assetName,
        }),
      )
      .then((response) => {
        if (response?.meta?.condition) return;
        const data = unwrapResult(response);
        if (Array.isArray(data)) dispatch(GetTeamShiftLogsAction(data));
      });
  };
}
export function GetTeamShiftLogsAction(payload) {
  return {
    type: ActionTypes.GET_TEAMSHIFTLOGS,
    payload,
    isLoading: false,
  };
}
export function LoadingInProgress() {
  return (dispatch) => {
    store.dispatch({
      type: ActionTypes.LOADINGINPROGRESS,
      isLoading: true,
    });
  };
}